import React from 'react';
import {FormattedMessage} from 'react-intl';
import OrderInspection from './OrderInspection';
import Empty from '../../../_common/components/Empty';
import Tabs from '../../../_common/components/Tabs';
import ButtonAction from '../../../_common/components/ButtonAction';
import {useOrderDetailsUIGlobalContext} from '../OrderDetailsUIGlobalContext';
import {
  useOrderDetailsUIInspectionsListContext
} from '../OrderDetailsUIInspectionsListContext';
import {OrderDetailsTaskProvider} from '../OrderDetailsTaskContext';
import {
  OrderDetailsUIInspectionProvider,
  useOrderDetailsUIInspectionContext
} from '../OrderDetailsUIInspectionContext';
import {
  StreetsProvider
} from '../../../_common/components/CitiesAndStreets';
import {
  DecisionTreeShumaTypesOptionsContextProvider
} from '../../../_common/components/DecisionTreeOptions';
import {
  OrderDetailsUINewInspectionProvider,
  useOrderDetailsUINewInspectionContext
} from '../OrderDetailsUINewInspectionContext';
import {
  useOrderDetailsUIOrderContext
} from '../OrderDetailsUIOrderContext';
import {TaskAndNotesGridProvider} from '../../../_common/contexts/TaskAndNotesGridContext';

const TabOrderInspections = () => {
  const {orderID} = useOrderDetailsUIGlobalContext();
  const {
    formikOrderInspections,
    handleCreateInspectionForLinkedOrder
  } = useOrderDetailsUIInspectionsListContext();
  const {getOrderData, oldInspectionsForms} = useOrderDetailsUIOrderContext();
  const {values, isValid, dirty} = formikOrderInspections;
  const {inspections} = values;
  const inspectionsTabs = inspections.map((item, index) => {
    const {shumaID} = inspections[index];

    if (oldInspectionsForms) {
      return {
        key: index,
        title: `דוח ${Boolean(item.firmShumaID) ? item.firmShumaID : 'חדש'}`,
        icon: <i className="flaticon2-file-1"/>,
        content: shumaID
          ? (
            <StreetsProvider>
              <DecisionTreeShumaTypesOptionsContextProvider>
                <OrderDetailsUIInspectionProvider inspectionDetails={item}>
                  <OrderInspection
                    shumaID={shumaID}
                    useContext={useOrderDetailsUIInspectionContext}
                  />
                </OrderDetailsUIInspectionProvider>
              </DecisionTreeShumaTypesOptionsContextProvider>
            </StreetsProvider>
          )
          : (
            <StreetsProvider>
              <DecisionTreeShumaTypesOptionsContextProvider>
                <OrderDetailsUINewInspectionProvider index={index}>
                  <OrderInspection
                    shumaID={shumaID}
                    useContext={useOrderDetailsUINewInspectionContext}
                  />
                </OrderDetailsUINewInspectionProvider>
              </DecisionTreeShumaTypesOptionsContextProvider>
            </StreetsProvider>
          )
      };
    } else {
      return {
        key: index,
        title: `דוח ${Boolean(item.firmShumaID) ? item.firmShumaID : 'חדש'}`,
        icon: <i className="flaticon2-file-1"/>,
        content: shumaID
          ? (
            <StreetsProvider>
              <DecisionTreeShumaTypesOptionsContextProvider>
                <OrderDetailsUIInspectionProvider inspectionDetails={item}>
                  <TaskAndNotesGridProvider shumaID={shumaID}>
                    <OrderDetailsTaskProvider>
                      <OrderInspection
                        shumaID={shumaID}
                        useContext={useOrderDetailsUIInspectionContext}
                      />
                    </OrderDetailsTaskProvider>
                  </TaskAndNotesGridProvider>
                </OrderDetailsUIInspectionProvider>
              </DecisionTreeShumaTypesOptionsContextProvider>
            </StreetsProvider>
          )
          : (
            <StreetsProvider>
              <DecisionTreeShumaTypesOptionsContextProvider>
                <OrderDetailsUINewInspectionProvider index={index}>
                  <TaskAndNotesGridProvider shumaID={shumaID}>
                    <OrderDetailsTaskProvider>
                      <OrderInspection
                        shumaID={shumaID}
                        useContext={useOrderDetailsUINewInspectionContext}
                      />
                    </OrderDetailsTaskProvider>
                  </TaskAndNotesGridProvider>
                </OrderDetailsUINewInspectionProvider>
              </DecisionTreeShumaTypesOptionsContextProvider>
            </StreetsProvider>
          )
      };
    }
  });

  const tabsWithShumaID = inspections.filter(item => Boolean(item.shumaID)).length;
  const allTabsHasShumaID = inspectionsTabs.length === tabsWithShumaID;

  const handleClick = async () => {
    await handleCreateInspectionForLinkedOrder();
    await getOrderData(orderID);
  };

  return inspectionsTabs && inspectionsTabs.length > 0 ? (
    <div>
      <Tabs items={inspectionsTabs}/>
      <ButtonAction
        useIcon={'/media/common/Check-in-circle_white.svg'}
        label={
          <FormattedMessage
            id={'tab-order-inspections-button-create-inspections'}
            defaultMessage={'Create inspections'}
          />
        }
        onClick={handleClick}
        disabled={!(isValid && dirty) || allTabsHasShumaID}
        customClassnames={'d-block my-8 mx-auto'}
      />
    </div>
  ) : <Empty customContainerClassname={'py-10'}/>;
};

export default TabOrderInspections;
